import { Icon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const Wishlist = (props: IconProps) => (
  <Icon width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M14.7129 28.7385C22.4129 28.7385 28.7129 22.4385 28.7129 14.7385C28.7129 7.03851 22.4129 0.73851 14.7129 0.73851C7.01289 0.73851 0.712891 7.03851 0.712891 14.7385C0.712891 22.4385 7.01289 28.7385 14.7129 28.7385Z" />
    <path d="M7.99624 11.1229H6.5459V20.5719H22.9739V11.1229" fill="white" />
    <path
      fill="white"
      d="M7.99624 11.1229H6.5459V20.5719H22.9739V11.1229"
      stroke="#131818"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5459 11.1229L7.75142 12.0836"
      fill="white"
      stroke="#131818"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12 7.32657L14.7612 5.40517L22.9737 11.1229" fill="white" />
    <path
      fill="white"
      d="M12 7.32657L14.7612 5.40517L22.9737 11.1229"
      stroke="#131818"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12.2198 16.6237L6.82129 14.7147L9.72198 6.52084L22.6976 11.1136L22.5861 11.4297" fill="white" />
    <path
      fill="white"
      d="M12.2198 16.6237L6.82129 14.7147L9.72198 6.52084L22.6976 11.1136L22.5861 11.4297"
      stroke="#131818"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5459 11.1229L8.53548 9.73767"
      fill="white"
      stroke="#131818"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.9744 11.1229L16.6523 16.1743"
      stroke="#131818"
      fill="white"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5459 20.5719L14.7614 14.8572L22.9739 20.5719"
      fill="white"
      stroke="#131818"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.485 12.4394C18.72 12.1909 17.9131 12.4432 17.4182 13.0155C17.3543 12.2618 16.8496 11.5827 16.0852 11.3341C15.0663 11.0029 13.9728 11.5601 13.6415 12.5785C13.517 12.9613 13.5181 13.3542 13.6217 13.7139C13.6367 13.766 13.6544 13.8175 13.6737 13.868C13.6737 13.868 13.6754 13.8717 13.6775 13.8766C13.7027 13.942 13.7328 14.0059 13.765 14.0682C13.9438 14.4622 14.3518 15.3689 14.6701 16.1538C14.996 17.0106 15.3122 17.971 15.4764 18.8219C15.4764 18.8219 17.2356 17.2849 19.5955 16.0872C19.6975 16.047 19.7958 15.9976 19.8897 15.9412C20.2741 15.7088 20.5796 15.3432 20.7293 14.8826C21.0606 13.8642 20.5033 12.7701 19.485 12.4394Z"
      fill="white"
      stroke="#131818"
      strokeWidth="0.6"
      strokeMiterlimit="10"
    />
  </Icon>
);
